import { LocalStorage, StorageName } from '@/utils/storage';
import accountApi from '@/api/accountApi';
import ssoApi from '@/api/ssoApi';
import commonApi from '@/api/commonApi';
import productApi from '@/api/productApi';
import orderApi from '@/api/orderApi';
import newsApi from '@/api/newsApi';
import inquiryPriceApi from '@/api/inquiryPriceApi';
import industryApi from '@/api/industryApi';
import productDetailApi from '@/api/productDetailApi';
import customerApi from '@/api/customerApi';
import submitOrderApi from '@/api/submitOrderApi';
import profileApi from '@/api/profileApi';
import manufacturerApi from '@/api/manufacturerApi';
import payment from '@/api/payment';
import topicApi from '@/api/topicApi';
import businessContactApi from '@/api/businessContactApi';
import pointApi from '@/api/pointApi';
import qualificationCertificateApi from '@/api/qualificationCertificateApi';
// 用户登录
export const login = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    accountApi.login(data).then(result => {
      if (result.Success) {
        LocalStorage.setItem({ name: StorageName.user.loginInfo, value: result.Data, expires: 86400000 });
        commit('SET_USER_LOGIN_INFO', result.Data);
      }
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};

export const register = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    accountApi.register(data).then(result => {
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};

// 退出登陆
export const signOut = ({ commit }) => {
  accountApi.logout();
  LocalStorage.removeItem(StorageName.user.loginInfo);
  commit('SET_USER_LOGIN_INFO', {});
};

// 判断是否登陆
export const isLogin = ({ commit }) => {
  const user = LocalStorage.getItem(StorageName.user.loginInfo);
  if (user) {
    commit('SET_USER_LOGIN_INFO', user);
  }
};

// SKF 获取SKF信息
export const getSkfSettings = ({ commit }, data) => {
  return ssoApi.getSkfSettings();
};

// SKF SSO登陆
export const skfAutoLogin = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    ssoApi.skfAutoLogin(data).then(result => {
      if (result.Success) {
        LocalStorage.setItem({ name: StorageName.user.loginInfo, value: result.Data, expires: 86400000 });
        commit('SET_USER_LOGIN_INFO', result.Data);
      }
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};

// 获取轮播图
export const getBannerByKey = ({ commit }, key) => {
  return commonApi.getBannerByKey(key);
};
export const getHotKeywords = ({ commit }, take) => {
  return commonApi.getHotKeywords(take);
};
// 品牌中心
export const getRecommendedManufacturers = ({ commit }) => {
  return manufacturerApi.getRecommendedManufacturers();
};
export const getManufacturers = ({ commit }, params) => {
  return manufacturerApi.getManufacturers(params);
};
// 资质证书
export const getAllQualificationCertificates = ({ commit }) => {
  return qualificationCertificateApi.getAllQualificationCertificates();
};
// 获取总积分
export const getTotalPoints = ({ commit }) => {
  return pointApi.getTotalPoints();
};
// 获取积分记录
export const pointHistory = ({ commit }, params) => {
  return pointApi.pointHistory(params);
};
// 业务联系
export const addBusinessContact = ({ commit }, params) => {
  return businessContactApi.addBusinessContact(params);
};
// country
export const getStatesByCountryId = ({ commit }, id) => {
  return commonApi.getStatesByCountryId(id);
};
export const getCitiesByStateId = ({ commit }, id) => {
  return commonApi.getCitiesByStateId(id);
};
// 批量询价
export const inquiryPriceDownload = ({ commit }) => {
  return inquiryPriceApi.inquiryPriceDownload();
};
export const inquiryPriceUpload = ({ commit }, params) => {
  return inquiryPriceApi.inquiryPriceUpload(params);
};
// 鼎阳topic
export const topicGetByKey = ({ commit }, key) => {
  return topicApi.topicGetByKey(key);
};
// 鼎阳动态
export const newsGetPagedList = ({ commit }, params) => {
  return newsApi.newsGetPagedList(params);
};
// 新闻详情
export const newsGetDetail = ({ commit }, id) => {
  return newsApi.newsGetDetail(id);
};
// 获取前端分类
export const getCategoryGroups = ({ commit }) => {
  return productApi.getCategoryGroups();
};
// 获取前端分类楼层
export const getCategoryFloors = ({ commit }) => {
  return productApi.getCategoryFloors();
};
// 获取最新公告
export const getLatestAnnounce = ({ commit }) => {
  return commonApi.getLatestAnnounce();
};
// 获取最近鼎阳动态
export const getRecentNews = ({ commit }) => {
  return commonApi.getRecentNews();
};
// 收藏商品
export const wishlistSave = ({ commit }, params) => {
  return productApi.wishlistSave(params);
};
// 取消收藏商品
export const wishlistDeleteByProductId = ({ commit }, id) => {
  return productApi.wishlistDeleteByProductId(id);
};
// 获取协议商品
export const searchAgreementProducts = ({ commit }, params) => {
  return productApi.searchAgreementProducts(params);
};
// 获取已购买的协议商品
export const searchPurchaseAgreementProducts = ({ commit }, params) => {
  return productApi.searchPurchaseAgreementProducts(params);
};
// 获取已购买的商品
export const searchPurchaseProducts = ({ commit }, params) => {
  return orderApi.searchPurchaseProducts(params);
};
// 获取购物车商品信息
export const getShoppingCart = ({ commit }) => {
  return new Promise((resolve, reject) => {
    orderApi.getShoppingCart().then(result => {
      if (result.Success && result.Data) {
        commit('SET_SHOPPING_CART', result.Data.List);
      }
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};
// 删除购物车商品
export const deleteShoppingCart = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    orderApi.deleteShoppingCart(id).then(result => {
      dispatch('getShoppingCart');
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};
// 批量删除
export const batchDeleteShoppingCart = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    orderApi.batchDeleteShoppingCart(params).then(result => {
      dispatch('getShoppingCart');
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};
// 更新购物车商品
export const updateShoppingCart = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    orderApi.updateShoppingCart(params).then(result => {
      dispatch('getShoppingCart');
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};
// 加入购物车
export const addShoppingCart = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    orderApi.addShoppingCart(params).then(result => {
      dispatch('getShoppingCart');
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};
// 批量加入购物车
export const addMoreShoppingCart = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    orderApi.addMoreShoppingCart(params).then(result => {
      dispatch('getShoppingCart');
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};
// 获取商品属性列表
export const getAttributesByProductId = ({ commit }, id) => {
  return orderApi.getAttributesByProductId(id);
};
// 获取增值服务
export const getAdditionalServicesByProductId = ({ commit }, id) => {
  return orderApi.getAdditionalServicesByProductId(id);
};

// 获取行业信息
export const industryGetAll = ({ commit }) => {
  return industryApi.industryGetAll();
};
// 根据ID获取行业详情
export const industryGetInfoById = ({ commit }, id) => {
  return industryApi.industryGetInfoById(id);
};
// 详情
export const articleGetInfoById = ({ commit }, id) => {
  return industryApi.articleGetInfoById(id);
};
// 智能设备&工业详情
export const articleGetAll = ({ commit }, params) => {
  return industryApi.articleGetAll(params);
};
// 请求获得商品详细信息
export const loadProductInfo = ({ commit }, data) => {
  return productDetailApi.getById(data.id);
};
// 获取个人信息
export const profileInfo = ({ commit }) => {
  return customerApi.profileInfo();
};
// 根据ID获取个人信息
export const getProfileInfoById = ({ commit }, id) => {
  return customerApi.getProfileInfoById(id);
};
// 个人页面获取个人信息
export const getMyInfo = ({ commit }) => {
  return customerApi.getMyInfo();
};
// 更新个人信息
export const updateInfo = ({ commit }, params) => {
  return customerApi.updateInfo(params);
};
// 更新头像
export const updateAvatar = ({ commit }, params) => {
  return customerApi.updateAvatar(params);
};
// 获取企业信息
export const getMyEnterpriseInfo = ({ commit }) => {
  return customerApi.getMyEnterpriseInfo();
};
// 更新企业信息
export const updateEnterpriseInfo = ({ commit }, params) => {
  return customerApi.updateEnterpriseInfo(params);
};
// 会员权益
export const levelupInfo = ({ commit }) => {
  return customerApi.levelupInfo();
};
// 获取子账户
export const getSubAccount = ({ commit }) => {
  return customerApi.getSubAccount();
};
// 按页获取订单信息
export const getPagedOrders = ({ commit }, params) => {
  return orderApi.getPagedOrders(params);
};
// 上传文件
export const uploadFile = ({ commit }, params) => {
  return orderApi.uploadFile(params);
};
// 发送验证码
export const sendVerifyCode = ({ commit }, params) => {
  return commonApi.sendVerifyCode(params);
};
// 校验验证码
export const checkVerifyCode = ({ commit }, params) => {
  return commonApi.checkVerifyCode(params);
};
// 获取地区信息
export const getAllCountryInfo = ({ commit }, params) => {
  return commonApi.getAllCountryInfo(params);
};
// 修改手机号
export const changePhoneNo = ({ commit }, params) => {
  return accountApi.changePhoneNo(params);
};
// 修改邮箱
export const changeEmail = ({ commit }, params) => {
  return accountApi.changeEmail(params);
};
// 修改密码
export const changePassword = ({ commit }, params) => {
  return accountApi.changePassword(params);
};
// 重置密码
export const resetPassword = ({ commit }, params) => {
  return accountApi.resetPassword(params);
};
export const resetPasswordByPhoneNo = ({ commit }, params) => {
  return accountApi.resetPasswordByPhoneNo(params);
};
// 添加购物车
export const addShoppingCartInProductDetail = ({ commit }, data) => {
  return productDetailApi.addShoppingCart(data);
};

export const loadInvoiceAddress = ({ commit }) => {
  return new Promise((resolve, reject) => {
    const address = [
      {
        addressId: '123456',
        name: 'CCC',
        state: '广东省',
        city: '广州市',
        area: '天河区',
        address: '燕岭路633号',
        phone: '152****0609',
        isDefault: true,
        active: true
      },
      {
        addressId: '123458',
        name: 'Kevin',
        province: '上海市',
        city: '上海市',
        area: '浦东新区',
        address: '沙新镇',
        phone: '158****0888',
        isDefault: false,
        active: false
      }
    ];
    resolve(address);
  });
};
export const loadAddress = ({ commit }, type) => {
  submitOrderApi.getAll(type).then(res => {
    if (res.Success) {
      commit('SET_USER_ADDRESS', res.Data.List);
    }
  });
};

// 商品搜索
export const searchAllProduct = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    productApi.searchAllProducts(data).then(result => {
      if (result.Success) {
        commit('SET_PRODUCT_SEARCH_RESULT', result.Data); // 搜索商品结果
        commit('SET_PRODUCT_FILTER_OUTPUT', result.Data); // 搜索结果Output
      }
      resolve(result);
    }).catch((error) => {
      console.log('error:', error);
      resolve(false);
    });
  });
};

// 获得商品详情页的商品规格
export const loadProductSpecifications = ({ commit }, data) => {
  return productDetailApi.getSpecificationAttributeList(data.productId);
};

// 获得商品详情页的相关商品
export const loadRelatedProductList = ({ commit }, data) => {
  return productDetailApi.getRelatedProductList(data.productId);
};

// 获得商品详情页的增值服务列表
export const loadGetAdditionalServicesList = ({ commit }, data) => {
  return productDetailApi.getAdditionalServicesByProductId(data.id);
};

// 获得商品详情页的s属性
export const loadProductAttributes = ({ commit }, data) => {
  return productDetailApi.getAttributesByProductId(data.id);
};

// 切换商品属性或增值服务
export const changeAttribute = ({ commit }, data) => {
  return productDetailApi.changeAttribute(data);
};

// 查询商品详情页其它所有型号商品
export const SearchSpuProducts = ({ commit }, data) => {
  return productDetailApi.searchSpuProducts(data);
};
// 获取Banner轮播图片
export const loadBannerItems = ({ commit }, key) => {
  return commonApi.getBannerByKey(key);
};

// 获取优选专区数据
export const loadActivityArea = ({ commit }, data) => {
  return commonApi.getActivityAreaByKey(data);
};
// 结算页面支付类型
export const getPaymentTypes = ({ commit }, data) => {
  return submitOrderApi.getPaymentTypes(data);
};

// 结算页面获取地址
export const getAllAddress = ({ commit }, data) => {
  return submitOrderApi.getAll(data);
};

// 结算页面新增地址
export const addAddress = ({ commit }, data) => {
  return submitOrderApi.addAllAddress(data);
};

// 结算页面编辑地址
export const editAddress = ({ commit }, data) => {
  return submitOrderApi.editAllAddress(data);
};

// 结算页面删除地址
export const deleteAddress = ({ commit }, data) => {
  return submitOrderApi.deleteAllAddress(data);
};

// 结算页面设置默认地址
export const setDefaulAddress = ({ commit }, data) => {
  return submitOrderApi.setDefaultAllAddress(data);
};

// 结算页面获取商品信息
export const preparePlaceOrder = ({ commit }, data) => {
  return submitOrderApi.preparePlaceOrder(data);
};

// 结算页面确认订单
export const confirmPlaceOrder = ({ commit }, data) => {
  return submitOrderApi.confirmPlaceOrder(data);
};

// 结算页面计算运费
export const refreshOrderShippingPrice = ({ commit }, data) => {
  return submitOrderApi.refreshOrderShippingPrice(data);
};

// 发票抬头管理获取列表
export const invoiceGetAll = ({ commit }, data) => {
  return profileApi.invoiceGetAll(data);
};
// 新增发票抬头
export const invoiceAdd = ({ commit }, data) => {
  return profileApi.invoiceAdd(data);
};
// 编辑发票抬头
export const invoiceEdit = ({ commit }, data) => {
  return profileApi.invoiceEdit(data);
};
// 删除发票抬头
export const invoiceDelete = ({ commit }, data) => {
  return profileApi.invoiceDelete(data);
};
// 设置默认发票抬头
export const invoiceSetDefault = ({ commit }, data) => {
  return profileApi.invoiceSetDefault(data);
};

// 商品详情页面收藏商品功能
export const saveWishlist = ({ commit }, data) => {
  return productDetailApi.saveWishlist(data);
};
// 商品详情页面取消收藏商品功能
export const deleteWishlistByProductId = ({ commit }, data) => {
  return productDetailApi.deleteWishlistByProductId(data);
};

// 支付页面查询信息
export const orderGetById = ({ commit }, data) => {
  return payment.orderGetById(data);
};

// 取消订单
export const CancelOrderProcess = ({ commit }, data) => {
  return profileApi.cancelOrderProcess(data);
};
// 获取收藏夹数据
export const WishlistGetAll = ({ commit }, data) => {
  return profileApi.wishlistGetAll(data);
};

// 获取个人中心订单列表
export const GetPagedOrders = ({ commit }, data) => {
  return profileApi.getPagedOrders(data);
};
// 获取所有对比商品
export const getAllCompareProduct = ({ commit }, data) => {
  return productDetailApi.getAllCompareProduct(data);
};
// 微信支付接口
export const wxQrCodePrepay = ({ commit }, data) => {
  return payment.wxQrCodePrepay(data);
};
// 支付宝支付接口
export const aliQrCodePay = ({ commit }, data) => {
  return payment.aliQrCodePay(data);
};
// 物流信息接口
export const queryKuaiDiInfo = ({ commit }, data) => {
  return payment.queryKuaiDiInfo(data);
};
// 配送方式
export const getShippmingMethods = ({ commit }) => {
  return submitOrderApi.getShippmingMethods();
};
// 获取包裹数量
export const getAllShipsByOrderId = ({ commit }, data) => {
  return orderApi.getAllShipsByOrderId(data);
};
// 获取物流信息
export const getLogisticsInfo = ({ commit }, data) => {
  return orderApi.getLogisticsInfo(data);
};
// 获取活动专区key
export const getManufacturerById = ({ commit }, data) => {
  return commonApi.getManufacturerById(data);
};
// 传当前选择的城市
export const getNearestWarehouseByCityId = ({ commit }, data) => {
  return commonApi.getNearestWarehouseByCityId(data);
};
// 代客下单
export const autoLoginForValetOrder = ({ commit }, data) => {
  return commonApi.autoLoginForValetOrder(data);
};
// 取消收藏
export const deleteWishlistInMyFavorite = ({ commit }, data) => {
  return profileApi.deleteWishlistInMyFavorite(data);
};
// 确认收货
export const orderReceiveItems = ({ commit }, data) => {
  return profileApi.orderReceiveItems(data);
};
// 退换货
export const orderRefund = ({ commit }, data) => {
  return profileApi.orderRefund(data);
};
// 获取信用额度
export const getCreditLinesHistory = ({ commit }, data) => {
  return profileApi.getCreditLinesHistory(data);
};
// 获取总的信用额度
export const getLeftCreditLinesAmount = ({ commit }) => {
  return profileApi.getLeftCreditLinesAmount();
};
// 获取行业设备详情
export const getAllProductsByEquipment = ({ commit }, data) => {
  return industryApi.getAllProductsByEquipment(data);
};
// 获取解决方案商品
export const getAllProductsByArticles = ({ commit }, data) => {
  return industryApi.getAllProductsByArticles(data);
};
// 获取支付提示语
export const getPaymentTips = ({ commit }) => {
  return payment.getPaymentTips();
};
// 返回是否支付
export const getCheckIsPayOrder = ({ commit }, data) => {
  return payment.getCheckIsPayOrder(data);
};
// 获取商品售后状态
export const getOrderRefundInfo = ({ commit }, data) => {
  return profileApi.getOrderRefundInfo(data);
};
// 获取在线qq
export const getOnlineQQ = ({ commit }) => {
  return commonApi.getOnlineQQ();
};
// 获取电话号码
export const getOnlinePhone = ({ commit }) => {
  return commonApi.getOnlinePhone();
};
// 获取优选专区商品
export const activityAreaGetCatalogProducts = ({ commit }, data) => {
  return commonApi.activityAreaGetCatalogProducts(data);
};
// 获取所有仓库经纬度
export const getAllBranchAndWarehouses = ({ commit }) => {
  return productDetailApi.getAllBranchAndWarehouses();
};
// 获取二维码
export const getWxCodeUnlimit = ({ commit }) => {
  return commonApi.getWxCodeUnlimit();
};
//
export const applicationEquipmentGetInfoById = ({ commit }, id) => {
  return industryApi.applicationEquipmentGetInfoById(id);
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js